import classNames from 'classnames';
import type { ScrolledContentState } from '../hooks/useScrolledContentState';
import type { DialogSize } from './Dialog.types';

type DialogClassNames = {
  root: string;
  container: string;
  header: string;
  content: string;
  footer: string;
};

const sizeClassName: { [Key in DialogSize]: string | null } = {
  auto: null,
  default: 'w-[384px]',
  large: 'w-[448px]',
};

export const getDialogClassNames = ({
  scrolledContentState,
  size,
  noFooter,
  className,
}: {
  scrolledContentState: ScrolledContentState;
  size: DialogSize;
  className?: string;
  noFooter?: boolean;
}): DialogClassNames => {
  const isHeaderShadowVisible =
    scrolledContentState === 'bottom' || scrolledContentState === 'middle';

  const isFooterShadowVisible =
    scrolledContentState === 'top' || scrolledContentState === 'middle';

  return {
    root: classNames('max-h-full p-14', className),
    container: classNames(
      'flex flex-col overflow-hidden min-w-[384px] max-h-[calc(100vh-var(--base-sizes-28))]', // overflow-hidden added to contain footer/header shadows
      'bg-default rounded-lg shadow-3xl',
      sizeClassName[size],
      noFooter && 'pb',
    ),
    header: classNames(
      'will-change-transform', // will-change-transform fixes incorrect rendering of shadow in Safari
      'flex flex-row items-center p',
      'justify-between',
      isHeaderShadowVisible && 'shadow-lg',
    ),
    content: classNames('grow overflow-auto px'),
    footer: classNames(
      'will-change-transform', // will-change-transform fixes incorrect rendering of shadow in Safari
      'p',
      isFooterShadowVisible && 'shadow-lg-reversed',
    ),
  };
};
